import { controls,grouped } from "../controls";
const account_installment_schedules = {
label: "Account Installment Schedules",
pageLabel: "Account Installment Schedules",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Installment Number",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "installment_number",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Installment Date",target: "installment_date",star:true}),
...controls.magicDate({ tab: "general", name: "installment_date", dateType: "ontype",isRequired:true }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Principal Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "principal_amount",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Interest Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "interest_amount",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Total"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "total",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Required Balance"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "required_balance",maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Os Balance"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "os_balance",maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Overdue"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "overdue",maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Os Interest"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "os_interest",maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Calcinterest"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "calcinterest",maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Account Installment Schedules",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Installment Number",accessor: "installment_number",},
{Header: "Installment Date",accessor: "installment_date",type:'date'},
{Header: "Principal Amount",accessor: "principal_amount",},
{Header: "Interest Amount",accessor: "interest_amount",},
{Header: "Total",accessor: "total",},
{Header: "Required Balance",accessor: "required_balance",},
{Header: "Os Balance",accessor: "os_balance",},
{Header: "Overdue",accessor: "overdue",},
{Header: "Os Interest",accessor: "os_interest",},
{Header: "Calcinterest",accessor: "calcinterest",},
]}};
export default account_installment_schedules;